import { CORE_PINNED_BLOCK_HEIGHTS } from "../pinned.js";
import { SOL_WALLET, SOL_USDC_MINT } from "../../integration.js";
export const SOLANA_TEST_CONFIG = {
    balance: { address: SOL_WALLET },
    tokenBalance: {
        address: SOL_WALLET,
        token: SOL_USDC_MINT,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.solana,
        fixture: "getBlockByNumberSolana",
    },
    balanceQuery: {
        address: SOL_WALLET,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.solana,
        fixture: "getBalanceSolana",
    },
};
